import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { PromotionCodeLog } from '../model/promotion-code-log';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class PromotionCodeLogService {

  http: HttpClientService;
  cookie: CookiesService;
  objAction: Action;
  data: PromotionCodeLog;
  constructor(http: HttpClientService, cook: CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
   getPromotionCodeLog():   Observable<PromotionCodeLog[]> {
     this.objAction.path = 'api/PromotionCodeLog/GetPromotionCodeLog';
    return this.objAction.get();
  }

 getPromotionCodeLogByCode(code: string, filterDays: string):   Observable<PromotionCodeLog[]> {
    this.objAction.path = 'api/PromotionCodeLog/GetPromotionLogByCode?code=' + code + '&daysFilter=' + filterDays;
   return this.objAction.get();
 }

}



// WEBPACK FOOTER //
// ./src/app/section/report/services/promotion-code-log.service.ts